import { logoutMiddleware } from '@clearscore/redux.session-middleware';
import nativeBridgeMiddleware from '@clearscore/redux.native-bridge-middleware';
import monitoringMiddleware from '@clearscore/redux.monitoring-middleware';
import csauthMiddleware from '@shared/external-cs-auth.request-middleware';

export default [csauthMiddleware, monitoringMiddleware('core'), nativeBridgeMiddleware(), logoutMiddleware()];
